module.exports = function getResource(label, vars = []) {
    let resources = {
        productPrice: 'Price',
        fillSize: 'Fill Size',
        rating: 'Rating',
        ingredientHighlights: 'Ingredient Highlights',
        seeDetails: 'See Details'
    };

    return resources[label];
};
